
import { mapState } from 'vuex'
import { LOCAL_TRACKING_SITES } from '@/utils/const'
export default {
  props: {
    value: {
      type: String,
      default: 'international',
    },
  },
  computed: {
    ...mapState({
      site: (state) => state.site,
    }),
    // 本地件查询站点开关：前端硬编码（ID/MY/VN/TH）
    isLocalTrackingSupported() {
      return LOCAL_TRACKING_SITES.includes(this.site?.toUpperCase())
    },
    queryType() {
      return this.value
    },
  },
  methods: {
    switchTab(type) {
      this.$emit('input', type)
      this.$emit('change', type)
    },
  },
}
